import styled from 'styled-components'
import { TableContainer } from './styled'

export const DeliveredTableContainer = styled(TableContainer)`
  padding: 12px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  .process-table {
    padding: 0;
    background: transparent;
    border-radius: 0;
  }

  .process-table > div {
    background: #ffffff;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    overflow: visible;
  }

  .process-table > div::after {
    display: none;
  }

  .process-table thead {
    background: #eff5fb;
  }

  .process-table thead tr,
  .process-table th {
    border-bottom: 0;
  }

  .process-table th {
    padding: 16px 20px;
    color: #163247;
    font-size: 0.875rem;
    font-weight: 700;
    letter-spacing: 0.01em;
    text-align: left;
    text-transform: none;
  }

  .process-table th:first-child {
    border-radius: 12px 0 0 12px;
  }

  .process-table th:last-child {
    border-radius: 0 12px 12px 0;
  }

  .process-table th:nth-child(-n + 2),
  .process-table tbody td:nth-child(-n + 2) {
    padding-right: 8px;
    padding-left: 8px;
    text-align: center;
  }

  .process-table tbody tr:nth-child(even):not(.selected):not(.isEditing):not(:hover) {
    background: #ffffff;
  }

  .process-table tbody td {
    padding: 8px 20px;
    color: #536b84;
    font-size: 0.875rem;
    text-align: left;
    border-bottom: 1px solid #e5e7eb;
  }

  .process-table tbody tr:last-child td {
    border-bottom: 0;
  }

  .process-table tbody td:nth-child(2) {
    color: #2d749c;
    font-weight: 700;
  }

  .process-table tbody td[data-label='Acciones'] > div {
    justify-content: flex-start;
  }
`
